// Copyright (c) StrangeBee 2023

import { AdminPermissions, OrgPermissions } from 'thehive-sdk';

interface CheckPermissionsParams {
    permissions: AdminPermissions[] | OrgPermissions[];
    permissionRequired: AdminPermissions | OrgPermissions;
}

export const checkPermissions = ({ permissionRequired, permissions = [] }: CheckPermissionsParams): boolean =>
    (permissions as string[]).includes(permissionRequired);
